import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHamburgerSetings = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 36.4,
	height: 24.7,
	viewBox: "0 0 36.4 24.7",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "menu_FILL1_wght500_GRAD0_opsz48",
		d: "M7.5,36.35a1.637,1.637,0,0,1-1.2-.5,1.7,1.7,0,0,1-.5-1.25,1.556,1.556,0,0,1,.5-1.175,1.681,1.681,0,0,1,1.2-.475h33a1.681,1.681,0,0,1,1.2.475,1.614,1.614,0,0,1,.5,1.225,1.707,1.707,0,0,1-1.7,1.7Zm0-10.65A1.707,1.707,0,0,1,5.8,24a1.614,1.614,0,0,1,.5-1.225A1.681,1.681,0,0,1,7.5,22.3h33A1.707,1.707,0,0,1,42.2,24a1.614,1.614,0,0,1-.5,1.225,1.681,1.681,0,0,1-1.2.475Zm0-10.65a1.681,1.681,0,0,1-1.2-.475,1.614,1.614,0,0,1-.5-1.225,1.707,1.707,0,0,1,1.7-1.7h33a1.637,1.637,0,0,1,1.2.5,1.7,1.7,0,0,1,.5,1.25,1.556,1.556,0,0,1-.5,1.175,1.681,1.681,0,0,1-1.2.475Z",
		transform: "translate(-5.8 -11.65)",
		fill: "#fff"
	})
});
export { SvgHamburgerSetings as ReactComponent };
